const tracker = window.__myWebLogTracker__ || {}

function sendUser(user) {
    if (typeof tracker.registUser === 'function') {
        tracker.registUser(user)
    }
}

export { sendUser }
